'use client'

import EventListSide from "@/components_mobile/side_board/event_list"
import ChatLayout from "../chat/chat"
import UserLayout from "@/components/user/user-info"
import UserRank from "@/components_mobile/side_board/user_rank"
import { BannerContext } from "@/context/bannerContext"
import { useContext } from "react"
import TopBanner from "@/components/etc/top_banner"

export default function RightSide() {
    const { main_top_banner, sub_bottom_banner, site_banner } = useContext(BannerContext)
    return (
        <aside className="right-side">
            <TopBanner bannerUrl={main_top_banner[3]} />
            
            <UserLayout />
            <ChatLayout />
            <TopBanner bannerUrl={site_banner[0]} />
            <TopBanner bannerUrl={site_banner[1]} />
            <TopBanner bannerUrl={site_banner[2]} />
            <EventListSide />
            {/* <UserRank /> */}
            <TopBanner bannerUrl={sub_bottom_banner[0]} />
            <TopBanner bannerUrl={sub_bottom_banner[1]} />
            <TopBanner bannerUrl={sub_bottom_banner[2]} />
            <TopBanner bannerUrl={sub_bottom_banner[3]} />
        </aside>
    )
}